// extracted by mini-css-extract-plugin
export default {"main":"ModalEditarAsignaturaAsistencias_main__3YZ6H","intro":"ModalEditarAsignaturaAsistencias_intro__F0hXr","input":"ModalEditarAsignaturaAsistencias_input__G8wFN"};